// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1E4yO","option":"styles_option__52Bui","selected":"styles_selected__29ncV"};